"use client";
import buildmapperagentIcon from "@/assets/sidenav/BuildMapperAgent.svg";
import leadDataIcon from "@/assets/sidenav/lead-data.svg";
import crmIcon from "@/assets/sidenav/crm.svg";
import contactsIcon from "@/assets/sidenav/contacts.svg";
import quotesIcon from "@/assets/sidenav/quotes.svg";
// import marketingIcon from "@/assets/sidenav/marketing-auto.svg";
import signIcon from "@/assets/sidenav/sign.svg";
import invoicingIcon from "@/assets/sidenav/invoice.svg";
import calendarIcon from "@/assets/sidenav/calendar.svg";
import documentsIcon from "@/assets/sidenav/documents.svg"
import allAppsIcon from "@/assets/apps/allApps.svg";
import integrationIcon from "@/assets/integration/integration.svg";
// import discussIcon from "@/assets/sidenav/discuss.svg";
// import analyticsIcon from "@/assets/sidenav/analytics.svg"
import { IPrompts, SideNavMenu } from "@/components/side-nav-menu/side-nav";
import { useCallback, useEffect, useState } from "react";
import { getDashboardPrompts } from "./service";
import { useLocation } from "react-router-dom";

const LINK_ICON_STYLE = "size-[25px] flex-shrink-0 hover:scale-125";
const links1 = [
  {
    label: "BuildMapper Agent",
    href: "/dashboard/buildmapper_agent",
    icon: (
      <img
        src={buildmapperagentIcon}
        alt="lead data icon"
        className={LINK_ICON_STYLE}
        title="BuildMapper Agent"
      />
    ),
  },
  {
    label: "Lead Data",
    href: "explore_leads",
    icon: (
      <img
        src={leadDataIcon}
        alt="lead data icon"
        className={LINK_ICON_STYLE}
        title="Lead Data"
      />
    ),
  },
  {
    label: "CRM",
    href: "/dashboard/CRM",
    icon: (
      <img
        src={crmIcon}
        alt="crm icon"
        className={LINK_ICON_STYLE}
        title="CRM"
      />
    ),
  },
  {
    label: "Calendar",
    href: "calendar",
    icon: (
      <img
        src={calendarIcon}
        alt="calendar icon"
        className={LINK_ICON_STYLE}
        title="Calendar"
      />
    ),
  },
  {
    label: "Contacts",
    href: "/dashboard/contacts",
    icon: (
      <img
        src={contactsIcon}
        alt="crm icon"
        className={LINK_ICON_STYLE}
        title="Contacts"
      />
    ),
  },

  {
    label: "Documents",
    icon: (
      <img
        src={documentsIcon}
        alt="documents icon"
        className={LINK_ICON_STYLE}
        title="Documents"
      />
    ),
    children: [
      {
        label: "Quotes",
        href: "/dashboard/quotes",
        icon: (
          <img
            src={quotesIcon}
            alt="quotes icon"
            className={LINK_ICON_STYLE}
            title="Quotes"
          />
        ),
      },
      {
        label: "Contracts",
        href: "/dashboard/contracts",
        icon: (
          <img
            src={signIcon}
            alt="contracts icon"
            className={LINK_ICON_STYLE}
            title="Contracts"
          />
        ),
      },
      {
        label: "Invoicing",
        href: "/dashboard/invoicing",
        icon: (
          <img
            src={invoicingIcon}
            alt="invoicing icon"
            className={LINK_ICON_STYLE}
            title="Invoicing"
          />
        ),
      },
    ],
  },
  // {
  //   label: "Quotes",
  //   href: "/dashboard/quotes",
  //   icon: (
  //     <img
  //       src={quotesIcon}
  //       alt="quotes icon"
  //       className={LINK_ICON_STYLE}
  //       title="Quotes"
  //     />
  //   ),
  // },
  // {
  //   label: "Contracts",
  //   href: "contracts",
  //   icon: (
  //     <img
  //       src={signIcon}
  //       alt="contracts icon"
  //       title="Contracts"
  //       className={LINK_ICON_STYLE}
  //     />
  //   ),
  // },
  // {
  //   label: "Invoicing",
  //   href: "invoicing",
  //   icon: (
  //     <img
  //       src={invoicingIcon}
  //       alt="invoicing icon"
  //       className={LINK_ICON_STYLE}
  //       title="Invoicing"
  //     />
  //   ),
  // },
  // {
  //   label: "Automation",
  //   href: "automation",
  //   icon: (
  //     <img
  //       src={marketingIcon}
  //       alt="marketing icon"
  //       className={LINK_ICON_STYLE}
  //       title="Marketing"
  //     />
  //   ),
  // },
  // {
  //   label: "Analytics",
  //   href: "#",
  //   icon: (
  //     <img
  //       src={analyticsIcon}
  //       alt="buildmapperagent icon"
  //       className={LINK_ICON_STYLE}
  //       title="BuildMapperagent"
  //     />
  //   ),
  // },
  // {
  //   label: "Discuss",
  //   href: "/dashboard/discuss/inbox",
  //   icon: (
  //     <img
  //       src={discussIcon}
  //       alt="discuss icon"
  //       className={LINK_ICON_STYLE}
  //       title="Discuss"
  //     />
  //   ),
  // },
  {
    label: "Integration",
    href: "/dashboard/integration",
    icon: (
      <img
        src={integrationIcon}
        alt="integration"
        className={LINK_ICON_STYLE}
        title="integration"
      />
    ),
  },
  {
    label: "All Apps",
    href: "/dashboard/all_apps",
    icon: (
      <img
        src={allAppsIcon}
        alt="all apps icon"
        className={LINK_ICON_STYLE}
        title="All Apps"
      />
    ),
  },
];

export default function Layout() {
  const [allPrompts, setAllPrompts] = useState<Record<string, IPrompts>>({});
  const [prompts, setPrompts] = useState<IPrompts>([]);

  const location = useLocation();

  const getPrompts = useCallback(async () => {
    const response = await getDashboardPrompts();
    console.log("get prompts response", response);
    setAllPrompts(response.data.prompts);
  }, []);

  useEffect(() => {
    getPrompts();
  }, []);

  useEffect(() => {
    console.log("prompts", allPrompts);
    console.log("location", location);
    let prom;
    const url = location.pathname;
    console.log("url", url);
    for (const k of Object.keys(allPrompts)) {
      if (url.toLowerCase().includes(k)) {
        prom = allPrompts[k];
      }
    }
    if (prom) {
      console.log("location prompts", prom);
      setPrompts(prom);
    }
  }, [allPrompts, location]);

  return <SideNavMenu navLinks={links1} prompts={prompts} />;
}
